import { createRoute, redirect } from '@tanstack/react-router'
import { Route as rootRoute } from '@/app/__root'
import { ROUTES } from '@/shared/constants/routes'
import { authClient } from '@/shared/lib/betterAuth/auth-client'
import { AUTH_TOKEN_KEY, AUTH_HEADER_SCHEME } from '@/shared/constants/auth'
import { getSecureItem } from '@/shared/lib/storage'
import { LoginPage } from './page.login'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: ROUTES.LOGIN,
  validateSearch: (search: Record<string, string>) => ({
    email: search.email || undefined,
    redirect: search.redirect || undefined,
    token: search.token || undefined,
    sessionToken: search.sessionToken || undefined,
  }),
  beforeLoad: async ({ search }) => {
    const { token: magicLinkToken, sessionToken } = search as {
      token?: string
      sessionToken?: string
    }
    if (magicLinkToken || sessionToken) return
    const storedToken = await getSecureItem(AUTH_TOKEN_KEY)
    if (storedToken) {
      const { data } = await authClient.getSession({
        fetchOptions: {
          headers: { Authorization: `${AUTH_HEADER_SCHEME} ${storedToken}` },
        },
      })
      if (data)
        throw redirect({
          to: (search as { redirect?: string }).redirect || ROUTES.HOME,
        })
    }
  },
  component: LoginPage,
})
